import { Injectable } from "@angular/core";
import { DatePipe } from '@angular/common';

@Injectable() export class DatePipeFormat extends DatePipe {
  public transform(value): any {
    return super.transform(value, 'y/MM/dd hh:mm a');
  }
}